module.exports = __webpack_public_path__ + "assets/projects/zissel/project-header.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/projects/zissel/project-header.jpg
// module id = 61
// module chunks = 0